module.exports = __webpack_public_path__ + "static/media/wifi.b5bd0f81.svg";